import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, Input, Popconfirm, Table, Switch, Modal } from "antd";
import CommonTable from "../../common/table/index.js";

import APIService from "../../Service/APIService";
import Config from "../../Config/Config.js";
import Swal from "sweetalert2";
import SectionHeader from "../../common/section-header/index.js";
// import { tableHeadersAccountProductPricing } from "../Utils/Constants.js";
import TableLink from "../../common/table/table-link/index.js";
import StatusIndicator from "../../common/status-indicator/index.js";
import TableOptionsCell from "../../common/table/table-options-cell/index.js";
import ModalView from "../../common/modal/index.js";
import TextInput from "../../common/text-input/index.js";
import CommonButton from "../../common/button/button.js";
import Text from "../../common/typography/text.js";
import Tags from "../../common/tags/index.js";
import DropdownComponent from "../../common/dropdown-input/index.js";
import RowIcon from "../../common/row-icon/index.js";
import QuickList from "../../common/list-component/quick-list.js";
import RequiredIcon from "../../icons/required-icon.js";
import { colors } from "../../theme/colors.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
const ProductPricing = (props) => {
  const { accountData } = props;
  const readOnly = props.readOnly === true;
  const { user, isReady } = useAuth();
  const userData = user;
  const [productsData, setProductsData] = React.useState([]);
  const [productsGroupData, setProductsGroupData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [productsUnderProductGroup, setProductsUnderProductGroup] = useState(
    []
  );
  const [viewModalRowData, setViewModalRowData] = useState();

  const [showViewModal, setShowViewModal] = useState(false);
  const [manufacturerName, setManufacturerName] = useState("");
  const [productName, setProductName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [price, setPrice] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const [productID, setProductID] = useState("");
  const [accountProductID, setAccountProductID] = useState("");

  // product group
  const [showProductGroupView, setShowProductGroupView] = useState(false);
  const [showProductGroupEdit, setShowProductGroupEdit] = useState(false);
  // products group form
  const [productGroupNameEdit, setProductGroupNameEdit] = useState(null);
  const [productGroupRateEdit, setProductGroupRateEdit] = useState(null);
  const [productGroupQCodeEdit, setProductGroupQCodeEdit] = useState(null);
  const [productGroupDiscountEdit, setProductGroupDiscountEdit] =
    useState(null);

  // const getProductsData = async (accountID, manufacturerID) => {
  //   if (accountID && manufacturerID) {
  //     const apiServe = new APIService();
  //     const response = await apiServe.getDataFromBackend(
  //       `getproductsfromaccountid?Type=Accounts&AccountID=${accountID}&ManufacturerID=${manufacturerID}`
  //     );
  //     // setProductsData(...productsData, response?.data?.data);
  //     return response?.data?.data;
  //   }
  // };

  const onToggleChange = (value, record, tempProds) => {
    if (readOnly) return;
    console.log("Toggle Value: ", value);
    console.log("Toggle Record: ", record);
    console.log("Products Data:", tempProds);
    const newData = [...tempProds];
    const index = newData.findIndex((item) => record.ID === item.ID);
    if (index > -1) {
      let item = newData[index];
      item.IsEnabled = !value;
      console.log("Item: ", item);
      newData.splice(index, 1, {
        ...item,
        ...record,
      });
      setProductsData(newData);
    }
  };

  const createFormatter = (cur, tempProds) => {
    switch (cur.formatterType) {
      case "toggle": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (text, record) => {
            return (
              <Switch
                disabled={readOnly}
                value={text}
                onChange={() => onToggleChange(text, record, tempProds)}
              />
            );
          },
        };
      }
    }
  };

  const generateSchema = (tempProds) => {
    const schema = Config.ColumnConfigs.ProductPricing;
    const columns = [];
    for (const cur of schema) {
      if (cur.isDisplayed && cur.isEditable) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          editable: true,
        });
      } else if (
        cur.isDisplayed &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null)
      ) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
        });
      } else if (
        cur.isDisplayed &&
        cur.isFormatter &&
        userData?.Type === "Admin"
      ) {
        // console.log("Formatter: ", cur);
        const obj = createFormatter(cur, tempProds);
        columns.push(obj);
      }
    }
    return columns;
  };

  const handleTableSubmit = async () => {
    if (readOnly) return;
    console.log("Products Data: ", productsData);

    const updatedProductsData = [
      {
        ID: accountProductID,
        ProductID: productID,
        Price: price,
        IsEnabled: isEnabled,
      },
    ];

    console.log(updatedProductsData, "product >>> 1");
    console.log("Products Data: 1", updatedProductsData);
    // addproducttoaccount
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.updateDataToBackend(
          updatedProductsData,
          "updateproducttoaccount"
        );
        console.log("Product Submit Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire({
            title: "Success!",
            text: "Product data saved successfully.",
            icon: "success",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Error in saving product data.",
            icon: "error",
          });
        }
      }
    });
  };
  // const [manufacturers, setManufacturers] = React.useState([]);

  // const getManufacturersFromAccount = async () => {
  //   const apiServe = new APIService();
  //   if (accountData && accountData?.ID) {
  //     const response = await apiServe.getDataFromBackend(
  //       `getmanufacturersfromaccount?ID=${accountData.ID}`
  //     );

  //     // setManufacturers(response?.data?.data);
  //     const manufacturers = response?.data?.data;
  //     let tempProducts = [];
  //     for (let i = 0; i < manufacturers.length; i++) {
  //       const tempProds = await getProductsData(
  //         accountData.ID,
  //         manufacturers[i].ID
  //       );
  //       tempProds.map((ele) => {
  //         ele["ManufacturerName"] = manufacturers[i].ManufacturerName;
  //         tempProducts.push(ele);
  //       });
  //       // tempProducts.push(...tempProds);
  //     }
  //     console.log("Temp Products: ", tempProducts);

  //     return tempProducts;
  //   }
  //   // return [];
  // };

  const getProductGroupsByAccountID = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `GetProductGroupsByAccountID?AccountID=${accountData.ID}`
    );

    console.log(response?.data?.data, "response >>> 1");
    return response?.data?.data;
  };

  React.useEffect(() => {
    // let tempProducts = [];
    // getManufacturersFromAccount().then((prodsData) => {
    //   setProductsData(prodsData);

    //   setColumns(generateSchema(prodsData));
    // });

    getProductGroupsByAccountID()
      .then((prodGroupData) => {
        setProductsGroupData(prodGroupData);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleShowViewModal = () => {
    setShowViewModal(true);
  };

  const getTableHeadersAccountProductPricing = (handleShowViewModal) =>
    userData.Type === "Admin"
      ? [
          {
            headerName: "Manufacturer",
            field: "ManufacturerName",
            filter: true,
            // flex: 1,
            // cellRenderer: (params) => (
            //   <TableLink
            //     value={params.data.ManufacturerName}
            //     path={`/Manufacturer/${params.data.ManufacturerID}`}
            //   />
            // ),
          },
          {
            headerName: "Product Name",
            field: "ProductName",
            filter: true,
            // flex: 1,
          },
          {
            headerName: "Product Code",
            field: "ProductCode",
            filter: true,
          },
          {
            headerName: "Price for this Account",
            field: "Price",
            filter: true,
            // flex: 1,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Price).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Price).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Availability",
            field: "",
            // flex: 1,
            cellRenderer: (params) => <StatusIndicator params={params} />,
          },
          {
            headerName: "Action",
            field: "",
            cellRenderer: () => (
              <TableOptionsCell
                optionOne="View"
                optionOneType="warning"
                optionOneClickFn={() => handleShowViewModal()}
              />
            ),
          },
        ]
      : [
          {
            headerName: "Manufacturer",
            field: "ManufacturerName",
            filter: true,
            // flex: 1,
            // cellRenderer: (params) => (
            //   <TableLink
            //     value={params.data.ManufacturerName}
            //     path={`/Manufacturer/${params.data.ManufacturerID}`}
            //   />
            // ),
          },
          {
            headerName: "Product Name",
            field: "ProductName",
            filter: true,
            // flex: 1,
          },
          {
            headerName: "Product Code",
            field: "ProductCode",
            filter: true,
          },
          {
            headerName: "Price for this Account",
            field: "Price",
            filter: true,
            // flex: 1,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Price).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Price).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Availability",
            field: "",
            // flex: 1,
            cellRenderer: (params) => <StatusIndicator params={params} />,
          },
        ];

  const tableHeadersAccountProductPricing =
    getTableHeadersAccountProductPricing(handleShowViewModal);

  const handleRowClick = (event) => {
    if (readOnly) return;
    setManufacturerName(event.data.ManufacturerName);
    setProductName(event.data.ProductName);
    setProductCode(event.data.ProductCode);
    setPrice(event.data.Price);
    setIsEnabled(event.data.IsEnabled);
    setProductID(event.data.ProductID);
    setAccountProductID(event.data.ID);
    console.log("Row clicked:", event.data);
  };

  const handleChangeEdit = (index, field, value) => {
    if (readOnly) return;
    const newProducts = [...productsUnderProductGroup];
    newProducts[index][field] = value;
    console.log(newProducts, "new products >>>>> 1");
    setProductsUnderProductGroup(newProducts);
  };

  const handleEditAccountProductGroupModal = (row) => {
    if (readOnly) return;
    console.log(row, "row edit >>>> 1");
    setShowProductGroupEdit(true);
    setProductGroupNameEdit(row?.ProductGroupName);
    setProductGroupDiscountEdit(row?.DiscountPercentage);
    setProductGroupRateEdit(row?.Rate);
    setProductGroupQCodeEdit(row?.QCode);
    setProductsUnderProductGroup(row?.Products);
    setViewModalRowData(row);
  };

  const handleViewAccountProductGroupModal = (row) => {
    setShowProductGroupView(true);
    setViewModalRowData(row);
    setProductsUnderProductGroup(row?.Products);
  };

  const getTableHeadersAccountProductGroup = (
    handleEditAccountProductGroupModal,
    handleViewAccountProductGroupModal
  ) =>
    userData?.Type === "Admin" && hasPermission(userData, "manage_accounts.edit")
      ? [
          {
            headerName: "Manufacturer Name",
            field: "ManufacturerName",
            filter: true,
          },
          {
            headerName: "Product Group Name",
            field: "ProductGroupName",
            filter: true,
            cellRenderer: (params) => {
              return (
                <CommonButton
                  variant="link"
                  onClick={() =>
                    handleViewAccountProductGroupModal(params.data)
                  }
                >
                  {params.data.ProductGroupName}
                </CommonButton>
              );
            },
          },
          {
            headerName: "HCPCS Code",
            field: "QCode",
            filter: true,
          },
          {
            headerName: "Rate",
            field: "Rate",
            filter: true,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Rate).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Rate).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Discount",
            field: "DiscountPercentage",
            filter: true,
            cellRenderer: (params) => {
              return `${params?.data?.DiscountPercentage}%`;
            },
          },
          {
            headerName: "Requires IVR",
            field: "IVR",
            filter: true,
            cellRenderer: (params) => (
              <Tags
                textColor={
                  params.data.IVR ? "successColorDark" : "failureColorDark"
                }
                tagBackground={
                  params.data.IVR ? "successColorLight" : "failureColorLight"
                }
                tagText={params.data.IVR ? "Yes" : "No"}
              />
            ),
          },
          {
            headerName: "Action",
            field: "",
            cellRenderer: (params) =>
              userData?.Type === "Admin" && hasPermission(userData, "manage_accounts.edit") && !readOnly ? (
                <>
                  <TableOptionsCell
                    optionOne="Edit"
                    optionOneType="warning"
                    optionOneClickFn={() =>
                      handleEditAccountProductGroupModal(params.data)
                    }
                    rowData={params.data}
                  />
                </>
              ) : null,
          },
        ]
      : [
          {
            headerName: "Manufacturer Name",
            field: "ManufacturerName",
            filter: true,
          },
          {
            headerName: "Product Group Name",
            field: "ProductGroupName",
            filter: true,
            cellRenderer: (params) => {
              return (
                <CommonButton
                  variant="link"
                  onClick={() =>
                    handleViewAccountProductGroupModal(params.data)
                  }
                >
                  {params.data.ProductGroupName}
                </CommonButton>
              );
            },
          },
          {
            headerName: "HCPCS Code",
            field: "QCode",
            filter: true,
          },
          {
            headerName: "Rate",
            field: "Rate",
            filter: true,
            cellDataType: "number",
            valueGetter: (params) =>
              parseFloat(String(params.data.Rate).replace(/[^0-9.-]+/g, "")),
            cellRenderer: (params) => {
              const value = parseFloat(
                String(params.data.Rate).replace(/[^0-9.-]+/g, "")
              );
              return `$${value.toLocaleString()}`;
            },
          },
          {
            headerName: "Discount",
            field: "DiscountPercentage",
            filter: true,
            cellRenderer: (params) => {
              return `${params?.data?.DiscountPercentage}%`;
            },
          },
          {
            headerName: "Requires IVR",
            field: "IVR",
            filter: true,
            cellRenderer: (params) => (
              <Tags
                textColor={
                  params.data.IVR ? "successColorDark" : "failureColorDark"
                }
                tagBackground={
                  params.data.IVR ? "successColorLight" : "failureColorLight"
                }
                tagText={params.data.IVR ? "Yes" : "No"}
              />
            ),
          },
        ];

  const tableHeadersAccountProductGroup = getTableHeadersAccountProductGroup(
    handleEditAccountProductGroupModal,
    handleViewAccountProductGroupModal
  );

  const handleAvailableToggle = () => {
    if (readOnly) return;
    setIsEnabled(!isEnabled);
  };

  const handleProductStatus = () => {
    if (readOnly) return;
    const newPrds = productsUnderProductGroup?.map((prd) => ({
      ...prd,
      IsEnabled: false,
    }));
    console.log(newPrds, "newPrds>>>> 1");
    setProductsUnderProductGroup(newPrds);
  };

  const handleToggleEnableStatus = (prd, ind) => {
    if (readOnly) return;
    // const newPrds = productsUnderProductGroup?.map((prd) => ({
    //   ...prd,
    //   IsEnabled: !prd.IsEnabled,
    // }));
    // console.log(newPrds, "newPrds>>>> 2");
    // console.log({ prd, ind }, "newPrds>>>> 3");
    // setProductsUnderProductGroup(newPrds);
    const newPrds = productsUnderProductGroup.map((item, i) =>
      i === ind ? { ...item, IsEnabled: !item.IsEnabled } : item
    );
    setProductsUnderProductGroup(newPrds);
  };

  const submitEditProductGroupHandler = async () => {
    if (readOnly) return;
    const finalProducts = productsUnderProductGroup.map((product) => ({
      ...product,
      Price:
        parseFloat(product?.StandardPrice) -
        (Number(productGroupDiscountEdit) *
          parseFloat(product?.StandardPrice)) /
          100,
    }));

    const editProductGroupObj = {
      ProductGroup: {
        ID: viewModalRowData?.ID,
        AccountID: accountData?.ID,
        ProductGroupName: viewModalRowData?.ProductGroupName,
        Rate: viewModalRowData?.Rate,
        QCode: viewModalRowData?.QCode,
        DiscountPercentage: Number(productGroupDiscountEdit),
      },
      Products: finalProducts,
    };
    console.log(editProductGroupObj, "editProductGroupObj >>>> 1");
    const apiServe = new APIService();
    Swal.fire({
      title: "Are you sure?",
      text: "You want to save the changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Save",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // setLoading(true);
        console.log("Post Object:", editProductGroupObj);
        const response = await apiServe.addDataToBackend(
          editProductGroupObj,
          "EditAccountProductGroup"
        );
        console.log(response);
        console.log("Saved Product Group Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire(
            "Saved Changes!",
            "Product Group has been edited.",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error has occurred",
          }).then(() => {
            // window.location.reload();
            // setLoading(false);
          });
          // setLoading(false);
        }
      }
    });
  };

  console.log({ productsGroupData }, "productsData >>>> 2");
  console.log({ viewModalRowData }, "PRODUCTS >>>>> 1");
  console.log({ productsUnderProductGroup }, "productsUnderProductGroup");

  return (
    <div>
      {accountData && productsData && (
        <div>
          <SectionHeader title="Product Catalog" showButton={false} />
          <CommonTable
            rowData={productsGroupData}
            columnDefs={tableHeadersAccountProductGroup}
            screen="AccountProductCatalog"
            loading={loading}
          />
        </div>
      )}
      <ModalView
        isOpen={showViewModal && !readOnly}
        onClose={() => setShowViewModal(false)}
        modalTitle="Edit Product Details"
        modalSubTitle="Changes made here will reflect on for account."
        textInputComponent={
          <div className="field-group-wrapper">
            <div className="field-group">
              <TextInput
                titleText="Manufacturer Name"
                placeholder="Manufacturer Name"
                value={manufacturerName}
                isDisabled
                setValue={(text) => setManufacturerName(text)}
              />
            </div>
            <div className="field-group">
              <TextInput
                titleText="Product Name"
                placeholder="Product Name"
                isDisabled
                value={productName}
                setValue={(name) => setProductName(name)}
              />
              <TextInput
                titleText="Product Code"
                placeholder="Product Code"
                isDisabled
                value={productCode}
                setValue={(code) => setProductCode(code)}
              />
            </div>
            <div className="field-group">
              <TextInput
                titleText="Set Price for this Account"
                placeholder="000.00"
                value={price}
                setValue={(price) => {
                  setPrice(price);
                }}
              />
            </div>
          </div>
        }
        footerButtonWrapper={
          <div className="footer-button-wrapper">
            {userData?.Type === "Admin" && (
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={() => handleTableSubmit(productCode)}
              >
                Save
              </CommonButton>
            )}
            <CommonButton
              variant="table"
              subVariant={isEnabled ? "failure" : "success"}
              onClick={handleAvailableToggle}
            >
              Make {isEnabled ? "Unavailable" : "Available"}
            </CommonButton>
          </div>
        }
      />
      {/* Product groups modal  */}
      <ModalView
        isOpen={showProductGroupEdit && !readOnly}
        onClose={() => setShowProductGroupEdit(false)}
        modalTitle={`Edit Product Group for ${accountData?.AccountName}`}
        textInputComponent={
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <div className="field-group-wrapper">
              <div className="field-group">
                <TextInput
                  titleText="Product Group Name"
                  placeholder="Product Group Name"
                  value={productGroupNameEdit}
                  isRequired
                  isDisabled
                  setValue={setProductGroupNameEdit}
                />
                <TextInput
                  titleText="Rate"
                  placeholder="Rate"
                  value={productGroupRateEdit}
                  isRequired
                  isDisabled
                  setValue={setProductGroupRateEdit}
                />
                <TextInput
                  titleText="HCPCS Code"
                  placeholder="HCPCS Code"
                  value={productGroupQCodeEdit}
                  isRequired
                  isDisabled
                  setValue={setProductGroupQCodeEdit}
                />
                <TextInput
                  titleText="Discount"
                  placeholder="Discount"
                  value={productGroupDiscountEdit}
                  isRequired
                  setValue={setProductGroupDiscountEdit}
                />
              </div>
            </div>

            {/* {isLoadingProducts ? (
              <Text variant="bodyText">Loading products...</Text>
            ) : productsUnderGroup?.length === 0 ? (
              <Text variant="bodyText">
                No products have been added to this product group yet.{" "}
              </Text>
            ) : null} */}
            {productsUnderProductGroup?.map((product, index) => {
              return (
                <div className="field-group-wrapper">
                  <div className="field-group-end">
                    <TextInput
                      titleText="Product Name"
                      placeholder="Product Name"
                      value={product?.ProductName}
                      isRequired
                      isDisabled
                      // setValue={setProductNameEdit}
                      onChange={(e) =>
                        handleChangeEdit(index, "ProductName", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Product Code"
                      placeholder="Product Code"
                      value={product?.ProductCode}
                      isRequired
                      isDisabled
                      onChange={(e) =>
                        handleChangeEdit(index, "ProductCode", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Units"
                      placeholder="Units"
                      value={product?.Units}
                      isRequired
                      parentClassName="small-width-button"
                      onChange={(e) => {
                        handleChangeEdit(index, "Units", e.target.value);
                      }}
                    />
                    <TextInput
                      titleText="Standard Price"
                      placeholder="Standard Price"
                      value={product?.StandardPrice}
                      isRequired
                      isDisabled
                    />
                    <TextInput
                      titleText="Discounted Price"
                      placeholder="{StandardPrice - Discount%}"
                      value={
                        product?.StandardPrice
                          ? (
                              product.StandardPrice -
                              (productGroupDiscountEdit *
                                product.StandardPrice) /
                                100
                            ).toFixed(2)
                          : ""
                      }
                      isRequired
                      isDisabled
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "16px",
                      }}
                      className="text-input-container small-width-button"
                    >
                      <div className="text-input-title">
                        <Text variant="tinyText">Availability</Text>
                        <RequiredIcon />
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleToggleEnableStatus(product, index)}
                      >
                        {product?.IsEnabled ? (
                          <RowIcon type="enabled" />
                        ) : (
                          <RowIcon />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        }
        footerButtonWrapper={
          <div className="footer-button-wrapper">
            <CommonButton
              variant="table"
              subVariant="success"
              onClick={submitEditProductGroupHandler}
            >
              Save
            </CommonButton>
            <CommonButton
              variant="table"
              subVariant="failure"
              onClick={handleProductStatus}
            >
              Make All Unavailable
            </CommonButton>
          </div>
        }
      />
      <ModalView
        isOpen={showProductGroupView}
        onClose={() => setShowProductGroupView(false)}
        modalTitle={`${viewModalRowData?.ProductGroupName} for ${accountData?.AccountName}`}
        textInputComponent={
          <>
            {productsUnderProductGroup?.length === 0 ? (
              <Text variant="bodyText">
                No products have been added to this product group yet.
              </Text>
            ) : (
              <div style={{ maxHeight: "400px" }}>
                <QuickList
                  items={productsUnderProductGroup}
                  primaryTitle="ProductName"
                  secondaryTitle="ProductCode"
                  price="Price"
                  tagKey="IsEnabled"
                  page="Accounts"
                  priceHeader="Units"
                  priceHeaderValue="Units"
                />
              </div>
            )}
          </>
        }
      />
    </div>
  );
};

export default ProductPricing;
